export default "__VITE_ASSET__ba5fd4dc__"